import axios from 'axios'

import { baseURL } from 'utils/io'

export const getBuildLogs = async (
  appId: string,
  buildId: string
): Promise<string> => {
  return (await axios.get(`${baseURL}/apps/${appId}/builds/${buildId}/logs`))
    .data as string
}
